import _ from 'lodash';
import { TableCell } from '@mui/material';
import { getNumberComma } from '../../utils/numberUtils';

const AccountSalesManageStaticTableCell = ({ data, headerRows }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    headerRows &&
    headerRows.map((field, fIndex) => {
      const findValue = _.find(data, { id: field.id });
      const formatValue = getNumberComma(findValue?.value);
      return (
        <TableCell
          sx={{ width: '100px', paddingLeft: 0 }}
          align="right"
          key={fIndex}
        >
          {formatValue}
        </TableCell>
      );
    })
  );
};

export default AccountSalesManageStaticTableCell;
